import type { AdvanceRoundAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { HorrorRaceState } from "../types/game-state";

export function validateAdvanceRound(
  state: HorrorRaceState,
  action: AdvanceRoundAction,
): ValidationResult {
  if (action.resolverId !== state.hostPlayerId) {
    return { valid: false, error: "Only the host can advance the round" };
  }
  if (state.phase !== "ROUND_RECAP") {
    return { valid: false, error: "Not in round recap phase" };
  }
  if (!state.players.every((p) => p.hasConfirmedRoundRecap)) {
    return {
      valid: false,
      error: "Not all players have confirmed the round recap",
    };
  }

  return { valid: true };
}
